import { useEffect } from "react"
import getAppStoreBadge from "../helpers/getAppStoreBadge"
import getGooglePlayBadge from "../helpers/getGooglePlayBadge"

const APPLE_STORE_URL = import.meta.env.VITE_APP_URL_APPLE_APP_STORE as string
const GOOGLE_PLAY_URL = import.meta.env.VITE_APP_URL_GOOGLE_PLAY_STORE as string

export default function DownloadRedirectPage() {
  useEffect(() => {
    const ua = navigator.userAgent
    if (/iPad|iPhone|iPod/.test(ua)) {
      window.location.href = APPLE_STORE_URL
    } else if (/Android/.test(ua)) {
      window.location.href = GOOGLE_PLAY_URL
    }
  }, [])

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-5 text-center">
      <h1 className="text-2xl font-semibold text-white">Download Filterly</h1>
      <p className="text-text-secondary text-sm">
        Redirecting you to the store...
      </p>
      <div className="flex items-center justify-center gap-3">
        <a href={GOOGLE_PLAY_URL}>
          <img
            alt="Get Filterly on Google Play"
            className="h-12"
            src={getGooglePlayBadge()}
          />
        </a>
        <a href={APPLE_STORE_URL}>
          <img
            alt="Download Filterly on the App Store"
            className="h-12"
            src={getAppStoreBadge()}
          />
        </a>
      </div>
    </div>
  )
}
